import type { AxiosResponse } from 'lib/axios';
import { api } from 'reactApp/api/axios.corsapi';

type RawRequestData = Record<string, any> | string;

type FlagsRPCType = {
    get: <T = unknown>(method: string, data?: RawRequestData, extra?: { url?: string }) => PromiseLike<{ body?: T } & AxiosResponse>;
    post: <T = unknown>(method: string, data?: RawRequestData, extra?: { url?: string }) => PromiseLike<{ body?: T } & AxiosResponse>;
    call: <T = unknown>(method: string, data?: RawRequestData, extra?: { url?: string }) => PromiseLike<{ body?: T } & AxiosResponse>;
};

const axiosCorsapiRpc: FlagsRPCType = {
    get: <T = unknown>(method: string, data?: RawRequestData) => api(method, data) as PromiseLike<{ body?: T } & AxiosResponse>,
    post: <T = unknown>(method: string, data?: RawRequestData) => api(method, data) as PromiseLike<{ body?: T } & AxiosResponse>,
    call: <T = unknown>(method: string, data?: RawRequestData) => api(method, data) as PromiseLike<{ body?: T } & AxiosResponse>,
};

export const getCorsApiRPC = () => axiosCorsapiRpc;
